import { Check, Copy } from "lucide-react";

import CustomTooltip from "../tooltip";
import PropTypes from "prop-types";
import classnames from "classnames";
import { useState } from "react";

const CopyToClipboard = (props) => {
  const {
    text = "",
    className = "",
    tooltipContent = "",
    id = "",
    onClick = () => {},
    testId = "",
    width = 17
  } = props;

  const [copied, setCopied] = useState(false);

  /**
   * Copy To ClipBoard
   * @param textField
   */
  const copyToClipBoard = async (textField) => {
    await navigator.clipboard.writeText(textField);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
    copyToClipBoard(text);
  };

  return (
    <>
      {copied ? (
        <Check
          size={width}
          className={classnames("text-success", className)}
          data-cy={`copy-${testId}`}
          id={id}
        />
      ) : (
        <Copy
          size={width}
          className={classnames(
            "cursor-pointer text-secondary hover:text-gray-700",
            className
          )}
          onClick={handleClick}
          data-cy={`copy-${testId}`}
          id={id}
        />
      )}
      {Boolean(tooltipContent) && (
        <CustomTooltip content={tooltipContent} target={id} />
      )}
    </>
  );
};

export default CopyToClipboard;

CopyToClipboard.propTypes = {
  text          : PropTypes.string,
  className     : PropTypes.string,
  tooltipContent: PropTypes.string,
  id            : PropTypes.string,
  children      : PropTypes.node,
  onClick       : PropTypes.func,
  width         : PropTypes.number,
  testId        : PropTypes.string
};
